// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xmf6t","newExpiryDate":"styles_newExpiryDate__19aXy","footer":"styles_footer__2MUDZ"};